'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _ci = require('../common/ci.utils');

var _throttleDebounce = require('throttle-debounce');

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CIResponsive = function () {
  function CIResponsive(config) {
    _classCallCheck(this, CIResponsive);

    _initialiseProps.call(this);

    this.config = (0, _ci.getInitialConfigLowPreview)(config);
    if (this.config.init) this.init();
    this.innerWidth = window.innerWidth;
  }

  _createClass(CIResponsive, [{
    key: 'init',
    value: function init() {
      document.addEventListener('lazybeforeunveil', this.onLazyBeforeUnveil.bind(this));
      this.process();
      window.addEventListener('resize', (0, _throttleDebounce.debounce)(100, this.onUpdateDimensions.bind(this)));
    }
  }, {
    key: 'onUpdateDimensions',
    value: function onUpdateDimensions() {
      this.process(true);

      if (this.innerWidth < window.innerWidth) {
        this.innerWidth = window.innerWidth;
      }
    }
  }, {
    key: 'onLazyBeforeUnveil',
    value: function onLazyBeforeUnveil(event) {
      var bgContainer = event.target;
      var bg = bgContainer.getAttribute('data-bg');
      var ciOptimizedUrl = bgContainer.getAttribute('ci-optimized-url');
      var isPreview = bgContainer.getAttribute('ci-preview') === 'true';
      var responsiveCss = bgContainer.getAttribute('ci-responsive-css');
      this.loadBackgroundImage(bg, isPreview, bgContainer, ciOptimizedUrl, responsiveCss);
    }
  }, {
    key: 'process',
    value: function process(isUpdate) {
      var _this = this;

      var images = (0, _ci.filterImages)(document.querySelectorAll('img[ci-src]'), 'ci-src');
      var backgroundImages = (0, _ci.filterImages)(document.querySelectorAll('[ci-bg-url]'), 'ci-bg-url');

      if (images.length > -1) {
        images.forEach(function (image) {
          _this.processImage(image, isUpdate);
        });
      }

      if (backgroundImages.length > -1) {
        this.styleElem = document.createElement('style');
        document.head.appendChild(this.styleElem);
        backgroundImages.forEach(function (image) {
          _this.processBackgroundImage(image, isUpdate);
        });
      }
    }
  }, {
    key: 'processImage',
    value: function processImage(image, isUpdate) {
      var isLazy = this.config.lazyLoading;
      var isSavedWindowInnerWidthMoreThanCurrent = this.innerWidth < window.innerWidth;

      if ((0, _ci.isResponsiveAndLoaded)(image) && !isSavedWindowInnerWidthMoreThanCurrent) {
        return;
      }

      var _getImageInlineProps = (0, _ci.getImageInlineProps)(image),
          imageWidth = _getImageInlineProps.imageWidth,
          imageHeight = _getImageInlineProps.imageHeight,
          imageRatio = _getImageInlineProps.imageRatio;

      var parentContainerWidth = (0, _ci.getParentWidth)(image, this.config, imageRatio && imageWidth);

      var _getImageProps = (0, _ci.getImageProps)(image),
          _getImageProps$params = _getImageProps.params,
          params = _getImageProps$params === undefined ? {} : _getImageProps$params,
          _getImageProps$sizes = _getImageProps.sizes,
          sizes = _getImageProps$sizes === undefined ? this.config.sizes : _getImageProps$sizes,
          ratio = _getImageProps.ratio,
          src = _getImageProps.src,
          fill = _getImageProps.fill,
          alignment = _getImageProps.alignment,
          isLazyCanceled = _getImageProps.isLazyCanceled;

      if (isLazyCanceled && isLazy || isUpdate) {
        isLazy = false;
      }

      if (!src) return;
      var isRelativeUrlPath = (0, _ci.checkIfRelativeUrlPath)(src);
      var resultImageWidth = imageRatio && imageWidth || parentContainerWidth;
      var imgSrc = (0, _ci.getImgSrc)(src, isRelativeUrlPath, this.config.baseUrl);
      var isSVG = (0, _ci.isImageSVG)(imgSrc);

      if (fill !== 100) {
        resultImageWidth = resultImageWidth * (isUpdate ? 1 : fill / 100);
      }

      var isPreview = resultImageWidth > 400;

      if (!(0, _ci.isOldBrowsers)()) {
        image.src = imgSrc;
        return;
      }

      var isAdaptive = !!sizes;
      if (isAdaptive && isUpdate) return;
      this.initImageClasses({
        image: image,
        isLazy: isLazy
      });

      if (this.config.imgLoadingAnimation && !isUpdate) {
        (0, _ci.setAnimation)(image, resultImageWidth);
      }

      var processProps = {
        ratio: ratio,
        params: params,
        image: image,
        isUpdate: isUpdate,
        isPreview: isPreview,
        imgSrc: imgSrc,
        parentContainerWidth: parentContainerWidth,
        resultImageWidth: resultImageWidth,
        isLazy: isLazy,
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        imageRatio: imageRatio,
        fill: fill,
        alignment: alignment,
        isSVG: isSVG
      };

      if (!isAdaptive) {
        this.processImageResponsive(processProps);
      } else {
        this.processImageAdaptive(_extends({}, processProps, {
          sizes: sizes
        }));
      }
    }
  }, {
    key: 'processBackgroundImage',
    value: function processBackgroundImage(image, isUpdate) {
      var isLazy = this.config.lazyLoading;
      var isSavedWindowInnerWidthMoreThanCurrent = this.innerWidth < window.innerWidth;

      if ((0, _ci.isResponsiveAndLoaded)(image) && !isSavedWindowInnerWidthMoreThanCurrent) {
        return;
      }

      var containerWidth = (0, _ci.getContainerWidth)(image, this.config);

      var _getBackgroundImagePr = (0, _ci.getBackgroundImageProps)(image),
          _getBackgroundImagePr2 = _getBackgroundImagePr.params,
          params = _getBackgroundImagePr2 === undefined ? {} : _getBackgroundImagePr2,
          _getBackgroundImagePr3 = _getBackgroundImagePr.sizes,
          sizes = _getBackgroundImagePr3 === undefined ? this.config.sizes : _getBackgroundImagePr3,
          ratio = _getBackgroundImagePr.ratio,
          src = _getBackgroundImagePr.src,
          isLazyCanceled = _getBackgroundImagePr.isLazyCanceled;

      if (isLazyCanceled && isLazy || isUpdate) {
        isLazy = false;
      }

      if (!src) return;
      var isRelativeUrlPath = (0, _ci.checkIfRelativeUrlPath)(src);
      var imgSrc = (0, _ci.getImgSrc)(src, isRelativeUrlPath, this.config.baseUrl);
      var isSVG = (0, _ci.isImageSVG)(imgSrc);
      var isPreview = containerWidth > 400;

      if (!(0, _ci.isOldBrowsers)()) {
        image.style.backgroundImage = 'url(' + imgSrc + ')';
        return;
      }

      var isAdaptive = !!sizes;
      if (isAdaptive && isUpdate) return;
      this.initImageBackgroundClasses({
        image: image,
        isLazy: isLazy
      });

      if (this.config.imgLoadingAnimation && !isUpdate) {
        (0, _ci.setAnimation)(image, containerWidth, true);
      }

      this.initImageBackgroundAttributes({
        image: image,
        isPreview: isPreview
      });
      var processProps = {
        ratio: ratio,
        params: params,
        image: image,
        isUpdate: isUpdate,
        isPreview: isPreview,
        imgSrc: imgSrc,
        containerWidth: containerWidth,
        isLazy: isLazy,
        isSVG: isSVG
      };

      if (!isAdaptive) {
        this.processBackgroundImageResponsive(processProps);
      } else {
        this.processBackgroundImageAdaptive(_extends({}, processProps, {
          sizes: sizes
        }));
      }

      this.bgImageIndex += 1;
    }
  }, {
    key: 'setSrc',
    value: function setSrc(image, url, propertyName, isLazy, imgSrc, isSVG) {
      var dataSrcAttr = this.config.dataSrcAttr;
      image.setAttribute(isLazy ? propertyName ? propertyName : 'data-src' : dataSrcAttr ? dataSrcAttr : 'src', isSVG ? imgSrc : url);
    }
  }, {
    key: 'setSrcset',
    value: function setSrcset(source, url, isLazy) {
      var dataSrcsetAttr = this.config.dataSrcsetAttr;
      source.setAttribute(isLazy ? 'data-srcset' : dataSrcsetAttr ? dataSrcsetAttr : 'srcset', url);
    }
  }, {
    key: 'setBackgroundSrc',
    value: function setBackgroundSrc(image, url, isLazy, imgSrc, isSVG) {
      var dataSrcAttr = this.config.dataSrcAttr;
      var resultLink = isSVG ? imgSrc : url;

      if (isLazy) {
        image.setAttribute(dataSrcAttr ? dataSrcAttr : 'data-bg', resultLink);
      } else {
        image.style.backgroundImage = 'url(\'' + resultLink + '\')';
      }
    }
  }, {
    key: 'wrap',
    value: function wrap(image, wrapper, isRatio, ratioBySize, ratio, imageRatio, imageWidth, imageHeight, fill, alignment) {
      if ((image.parentNode.className || '').indexOf('ci-image-wrapper') > -1 || (image.parentNode.parentNode.className || '').indexOf('ci-image-wrapper') > -1) {
        wrapper = image.parentNode;
        (0, _ci.addClass)(wrapper, 'ci-image-wrapper');
        wrapper.style.background = this.config.placeholderBackground;
        (0, _ci.setWrapperAlignment)(wrapper, alignment);

        if (isRatio) {
          (0, _ci.addClass)(wrapper, 'ci-image-wrapper-ratio');
        }

        wrapper.style.width = imageRatio ? imageWidth + 'px' : '100%';

        if (imageRatio && imageHeight) {
          wrapper.style.height = imageHeight + 'px';
        }

        if (fill !== 100 && !imageRatio) {
          wrapper.style.width = fill + '%';
        }

        return;
      }

      wrapper = wrapper || document.createElement('div');
      (0, _ci.addClass)(wrapper, 'ci-image-wrapper');
      wrapper.style.background = this.config.placeholderBackground;
      wrapper.style.width = imageRatio ? imageWidth + 'px' : '100%';
      (0, _ci.setWrapperAlignment)(wrapper, alignment);

      if (imageRatio && imageHeight) {
        wrapper.style.height = imageHeight + 'px';
      }

      if (fill !== 100 && !imageRatio) {
        wrapper.style.width = fill + '%';
      }

      if (isRatio && !imageRatio) {
        (0, _ci.addClass)(wrapper, 'ci-image-wrapper-ratio');
        wrapper.style.paddingBottom = (fill || 100) / (ratioBySize || ratio || this.config.ratio) + '%';
      }

      if (image.nextSibling) {
        image.parentNode.insertBefore(wrapper, image.nextSibling);
      } else {
        image.parentNode.appendChild(wrapper);
      }

      wrapper.appendChild(image);
      return wrapper;
    }
  }, {
    key: 'addSources',
    value: function addSources(image, previewSources, isLazy) {
      var _this2 = this;

      [].concat(_toConsumableArray(previewSources.slice(1).reverse())).forEach(function (_ref) {
        var mediaQuery = _ref.mediaQuery,
            srcSet = _ref.srcSet;

        var source = _this2.createSource(mediaQuery, srcSet, isLazy);

        (0, _ci.insertSource)(image, source);
      });
      (0, _ci.insertSource)(image, this.createSource(null, previewSources[0].srcSet, isLazy));
    }
  }, {
    key: 'addBackgroundSources',
    value: function addBackgroundSources(bgImageIndex, sources, returnCSSString) {
      var cssStyle = '';
      cssStyle += (0, _ci.createCSSSource)(null, sources[0].srcSet, bgImageIndex);
      [].concat(_toConsumableArray(sources.slice(1))).forEach(function (_ref2) {
        var mediaQuery = _ref2.mediaQuery,
            srcSet = _ref2.srcSet;
        cssStyle += (0, _ci.createCSSSource)(mediaQuery, srcSet, bgImageIndex);
      });

      if (returnCSSString) {
        return cssStyle;
      }

      this.styleElem.appendChild(document.createTextNode(cssStyle));
    }
  }, {
    key: 'createSource',
    value: function createSource(mediaQuery, srcSet, isLazy) {
      var source = document.createElement('source');

      if (mediaQuery) {
        source.media = mediaQuery;
      }

      this.setSrcset(source, srcSet, isLazy);
      return source;
    }
  }, {
    key: 'updateSources',
    value: function updateSources(image, previewSources, sources, isLazy) {
      var _this3 = this;

      var sourcesElems = image.parentNode.querySelectorAll('source');
      sourcesElems.forEach(function (elem, index) {
        _this3.setSrcset(elem, sources[index].srcSet, isLazy);
      });
    }
  }]);

  return CIResponsive;
}();

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.bgImageIndex = 0;

  this.loadBackgroundImage = function (bg, isPreview, bgContainer, ciOptimizedUrl, responsiveCss) {
    if (bg) {
      var optimizedImage = new Image();

      if (isPreview) {
        var previewImage = new Image();

        optimizedImage.onload = function () {
          if (_this4.config.imgLoadingAnimation) {
            (0, _ci.finishAnimation)(bgContainer, true);
          }

          bgContainer.style.backgroundImage = 'url(' + ciOptimizedUrl + ')';
          bgContainer.removeAttribute('ci-optimized-url');
          bgContainer.removeAttribute('data-bg');
          bgContainer.removeAttribute('ci-preview');

          if (responsiveCss) {
            _this4.styleElem.appendChild(document.createTextNode(responsiveCss));
          }
        };

        optimizedImage.src = ciOptimizedUrl;
        previewImage.src = bg;
      } else {
        optimizedImage.onload = function () {
          if (_this4.config.imgLoadingAnimation) {
            (0, _ci.finishAnimation)(bgContainer, true);
          }

          bgContainer.removeAttribute('data-bg');
          bgContainer.removeAttribute('ci-preview');

          if (responsiveCss) {
            _this4.styleElem.appendChild(document.createTextNode(responsiveCss));
          }
        };

        optimizedImage.src = bg;
      }

      bgContainer.style.backgroundImage = 'url(' + bg + ')';
    }
  };

  this.getPreviewWithRatioParams = function (_ref3) {
    var imgSrc = _ref3.imgSrc,
        params = _ref3.params,
        image = _ref3.image,
        parentContainerWidth = _ref3.parentContainerWidth;
    var cloudimageUrl = (0, _ci.generateUrl)(imgSrc, params, _this4.config, (0, _ci.updateSizeWithPixelRatio)(parentContainerWidth));
    var container = image.parentNode;
    var isPreviewImg = container.className.indexOf('ci-with-preview-image') > -1;

    var config = _extends({}, _this4.config);

    var previewQualityFactor = config.previewQualityFactor;
    var lowQualitySize = (0, _ci.getLowQualitySize)(params, previewQualityFactor);
    var url = (0, _ci.generateUrl)(imgSrc, _extends({}, params, lowQualitySize), config, (0, _ci.updateSizeWithPixelRatio)(parentContainerWidth / previewQualityFactor));
    return {
      isPreviewImg: isPreviewImg,
      container: container,
      cloudimageUrl: cloudimageUrl,
      url: url
    };
  };

  this.onImageLoad = function (_ref4) {
    var wrapper = _ref4.wrapper,
        image = _ref4.image,
        ratio = _ref4.ratio,
        fill = _ref4.fill;
    wrapper.style.background = 'transparent';

    if (!ratio) {
      wrapper.style.paddingBottom = (fill || 100) / (image.width / image.height || 1.5) + '%';
    }

    if (_this4.config.imgLoadingAnimation) {
      (0, _ci.finishAnimation)(image);
    }
  };

  this.onPreviewWithRatioImageLoad = function (wrapper, previewImg, image, ratio, fill) {
    wrapper.style.background = 'transparent';
    previewImg.style.display = 'none';

    if (!ratio) {
      wrapper.style.paddingBottom = (fill || 100) / (image.width / image.height || 1.5) + '%';
    }

    if (_this4.config.imgLoadingAnimation) {
      (0, _ci.finishAnimation)(image);
    }
  };

  this.getPreviewImg = function (_ref5) {
    var isPreviewImg = _ref5.isPreviewImg,
        container = _ref5.container,
        isRatio = _ref5.isRatio,
        isLazy = _ref5.isLazy,
        image = _ref5.image;
    var previewImg = null;

    if (isPreviewImg) {
      previewImg = container.querySelector('img.ci-image-preview');
    } else {
      previewImg = document.createElement('img');
      previewImg.className = (isRatio ? 'ci-image-ratio ' : '') + ' ci-image-preview' + (isLazy ? ' lazyload' : '');
      (0, _ci.addClass)(container, 'ci-with-preview-image');
      image.parentNode.insertBefore(previewImg, image);
    }

    return previewImg;
  };

  this.processImageAdaptive = function (props) {
    var ratio = props.ratio,
        params = props.params,
        image = props.image,
        isUpdate = props.isUpdate,
        isPreview = props.isPreview,
        imgSrc = props.imgSrc,
        parentContainerWidth = props.parentContainerWidth,
        isLazy = props.isLazy,
        sizes = props.sizes,
        fill = props.fill,
        alignment = props.alignment,
        isSVG = props.isSVG;
    var adaptiveSizes = (0, _ci.getAdaptiveSize)(sizes, _this4.config);

    var _getRatio = _this4.getRatio(ratio, params, adaptiveSizes),
        _getRatio2 = _slicedToArray(_getRatio, 2),
        ratioBySize = _getRatio2[0],
        isRatio = _getRatio2[1];

    var wrapper = null;
    wrapper = _this4.applyOrUpdateWrapper({
      isUpdate: isUpdate,
      image: image,
      isRatio: isRatio,
      ratioBySize: ratioBySize,
      ratio: ratio,
      isPreview: isPreview,
      fill: fill,
      alignment: alignment
    });
    if (isUpdate) return;
    if (isRatio) (0, _ci.addClass)(image, 'ci-image-ratio'); // todo do we need it?

    var fallbackImageUrl = (0, _ci.generateUrl)(imgSrc, params, _this4.config, parentContainerWidth);
    (0, _ci.wrapWithPicture)(image);

    var onImageLoad = function onImageLoad() {
      wrapper.style.background = 'transparent';
      wrapper.style.paddingBottom = '0';
      (0, _ci.removeClass)(image, 'ci-image-ratio');
      (0, _ci.removeClass)(wrapper, 'ci-image-wrapper-ratio');

      if (_this4.config.imgLoadingAnimation) {
        (0, _ci.finishAnimation)(image);
      }
    };

    if (!isPreview) {
      var sources = (0, _ci.generateSources)(imgSrc, params, adaptiveSizes, _this4.config, parentContainerWidth);

      _this4.addSources(image, sources, isLazy);

      _this4.setSrc(image, fallbackImageUrl, null, isLazy);

      if (_this4.config.imgLoadingAnimation) {
        image.onload = onImageLoad;
      }
    } else {
      var previewImg = null;
      var container = image.parentNode.parentNode;
      var pictureElem = container.querySelector('picture');
      previewImg = document.createElement('img');
      previewImg.className = (isRatio ? 'ci-image-ratio ' : '') + 'ci-image-preview' + (isLazy ? ' lazyload' : '');
      (0, _ci.addClass)(container, 'ci-with-preview-image');
      container.insertBefore(previewImg, pictureElem);
      (0, _ci.wrapWithPicture)(previewImg);

      if (_this4.config.imgLoadingAnimation && !isUpdate) {
        (0, _ci.setAnimation)(previewImg, parentContainerWidth);
      }

      var config = _extends({}, _this4.config);

      var previewQualityFactor = config.previewQualityFactor; // todo check if it's correct

      var url = (0, _ci.generateUrl)(imgSrc, params, _this4.config, Math.floor(parentContainerWidth / previewQualityFactor));

      var _sources = (0, _ci.generateSources)(imgSrc, params, adaptiveSizes, _this4.config, parentContainerWidth);

      var previewSources = (0, _ci.generateSources)(imgSrc, params, adaptiveSizes, _this4.config, parentContainerWidth, true);

      _this4.addSources(previewImg, previewSources, isLazy);

      _this4.addSources(image, _sources, isLazy);

      _this4.setSrc(previewImg, url, null, isLazy);

      _this4.setSrc(image, fallbackImageUrl, null, isLazy);

      image.onload = function () {
        onImageLoad();
        previewImg.style.display = 'none';
      };
    }
  };

  this.processImageResponsive = function (props) {
    var ratio = props.ratio,
        params = props.params,
        image = props.image,
        isUpdate = props.isUpdate,
        isPreview = props.isPreview,
        imgSrc = props.imgSrc,
        resultImageWidth = props.resultImageWidth,
        isLazy = props.isLazy,
        imageWidth = props.imageWidth,
        imageHeight = props.imageHeight,
        imageRatio = props.imageRatio,
        fill = props.fill,
        alignment = props.alignment,
        isSVG = props.isSVG;

    var _getRatio3 = _this4.getRatio(ratio, params),
        _getRatio4 = _slicedToArray(_getRatio3, 2),
        ratioBySize = _getRatio4[0],
        isRatio = _getRatio4[1];

    var wrapper = _this4.applyOrUpdateWrapper({
      isUpdate: isUpdate,
      image: image,
      isRatio: isRatio,
      ratioBySize: ratioBySize,
      ratio: ratio,
      isPreview: isPreview,
      imageWidth: imageWidth,
      imageHeight: imageHeight,
      imageRatio: imageRatio,
      fill: fill,
      alignment: alignment
    });

    if (isRatio) (0, _ci.addClass)(image, 'ci-image-ratio');

    if (isPreview && isRatio) {
      var _getPreviewWithRatioP = _this4.getPreviewWithRatioParams({
        imgSrc: imgSrc,
        image: image,
        params: params,
        parentContainerWidth: resultImageWidth
      }),
          isPreviewImg = _getPreviewWithRatioP.isPreviewImg,
          container = _getPreviewWithRatioP.container,
          cloudimageUrl = _getPreviewWithRatioP.cloudimageUrl,
          url = _getPreviewWithRatioP.url;

      var previewImg = _this4.getPreviewImg({
        isPreviewImg: isPreviewImg,
        container: container,
        isRatio: isRatio,
        isLazy: isLazy,
        image: image
      });

      if (_this4.config.imgLoadingAnimation && !isUpdate) {
        (0, _ci.setAnimation)(previewImg, (0, _ci.updateSizeWithPixelRatio)(resultImageWidth));
      }

      _this4.setSrc(previewImg, url, 'data-src', isLazy, imgSrc, isSVG);

      _this4.setSrc(image, cloudimageUrl, 'data-src', isLazy, imgSrc, isSVG);

      image.onload = _this4.onPreviewWithRatioImageLoad.bind(_this4, wrapper, previewImg, image, ratio, fill);
    } else {
      var _cloudimageUrl = (0, _ci.generateUrl)(imgSrc, params, _this4.config, (0, _ci.updateSizeWithPixelRatio)(resultImageWidth), imageWidth && imageHeight, imageHeight);

      image.onload = function () {
        _this4.onImageLoad({
          wrapper: wrapper,
          image: image,
          ratio: ratio,
          fill: fill
        });
      };

      _this4.setSrc(image, _cloudimageUrl, null, isLazy, imgSrc, isSVG);
    }
  };

  this.applyOrUpdateWrapper = function (props) {
    var isUpdate = props.isUpdate,
        image = props.image,
        isRatio = props.isRatio,
        ratioBySize = props.ratioBySize,
        ratio = props.ratio,
        imageWidth = props.imageWidth,
        imageHeight = props.imageHeight,
        imageRatio = props.imageRatio,
        fill = props.fill,
        alignment = props.alignment;
    var wrapper = null;

    if (!isUpdate) {
      wrapper = _this4.wrap(image, null, isRatio, ratioBySize, ratio || _this4.config.ratio, imageRatio, imageWidth, imageHeight, fill, alignment);
    } else {
      wrapper = (0, _ci.getWrapper)(image);

      if (isRatio && !imageRatio) {
        wrapper.style.paddingBottom = (fill || 100) / (ratioBySize || ratio || _this4.config.ratio) + '%';
      } else if (imageRatio) {
        wrapper.style.width = imageWidth + 'px';
        wrapper.style.height = imageHeight + 'px';
      }
    }

    return wrapper;
  };

  this.initImageClasses = function (_ref6) {
    var image = _ref6.image,
        isLazy = _ref6.isLazy;
    (0, _ci.addClass)(image, 'ci-image');

    if (isLazy) {
      (0, _ci.addClass)(image, 'lazyload');
    }
  };

  this.getRatio = function (ratio, params, adaptiveSize) {
    var ratioBySize = adaptiveSize ? (0, _ci.getRatioBySizeAdaptive)(params, adaptiveSize) : (0, _ci.getRatioBySizeSimple)(params);
    return [ratioBySize, !!(ratioBySize || ratio || _this4.config.ratio)];
  };

  this.initImageBackgroundClasses = function (_ref7) {
    var image = _ref7.image,
        isLazy = _ref7.isLazy;
    (0, _ci.addClass)(image, 'ci-bg');

    if (isLazy) {
      (0, _ci.addClass)(image, 'lazyload');
    }
  };

  this.initImageBackgroundAttributes = function (_ref8) {
    var image = _ref8.image,
        isPreview = _ref8.isPreview;

    if (isPreview) {
      image.setAttribute('ci-preview', true);
    }

    image.setAttribute('ci-bg-index', _this4.bgImageIndex);
  };

  this.processBackgroundImageResponsive = function (props) {
    var params = props.params,
        image = props.image,
        isUpdate = props.isUpdate,
        isPreview = props.isPreview,
        imgSrc = props.imgSrc,
        containerWidth = props.containerWidth,
        isLazy = props.isLazy,
        isSVG = props.isSVG;

    if (isPreview) {
      var config = _extends({}, _this4.config);

      var cloudimageUrl = (0, _ci.generateUrl)(imgSrc, params, _this4.config, (0, _ci.updateSizeWithPixelRatio)(containerWidth));
      var previewQualityFactor = config.previewQualityFactor;
      var lowQualitySize = (0, _ci.getLowQualitySize)(params, previewQualityFactor);
      var lowQualityUrl = (0, _ci.generateUrl)(imgSrc, _extends({}, params, lowQualitySize), config, (0, _ci.updateSizeWithPixelRatio)(containerWidth / previewQualityFactor));
      image.className = '' + image.className + (isLazy ? ' lazyload' : '');

      if (_this4.config.imgLoadingAnimation && !isUpdate) {
        (0, _ci.setAnimation)(image, containerWidth, true);
      }

      if (isLazy) {
        image.setAttribute('ci-optimized-url', cloudimageUrl);

        _this4.setBackgroundSrc(image, lowQualityUrl, isLazy, imgSrc, isSVG);
      } else {
        var responsiveCss = image.getAttribute('ci-responsive-css');

        _this4.loadBackgroundImage(lowQualityUrl, isPreview, image, cloudimageUrl, responsiveCss);
      }
    }
    /* Not Adaptive and No Preview */
    else {
        var _cloudimageUrl2 = (0, _ci.generateUrl)(imgSrc, params, _this4.config, (0, _ci.updateSizeWithPixelRatio)(containerWidth));

        if (!isLazy) {
          var tempImage = new Image();
          tempImage.src = _cloudimageUrl2;

          tempImage.onload = function () {
            if (_this4.config.imgLoadingAnimation) {
              (0, _ci.finishAnimation)(image, true);
            }
          };
        }

        _this4.setBackgroundSrc(image, _cloudimageUrl2, isLazy, imgSrc, isSVG);
      }
  };

  this.processBackgroundImageAdaptive = function (_ref9) {
    var imgSrc = _ref9.imgSrc,
        sizes = _ref9.sizes,
        params = _ref9.params,
        containerWidth = _ref9.containerWidth,
        isPreview = _ref9.isPreview,
        isLazy = _ref9.isLazy,
        image = _ref9.image;
    var adaptiveSizes = (0, _ci.getAdaptiveSize)(sizes, _this4.config);
    var sources = (0, _ci.generateSources)(imgSrc, params, adaptiveSizes, _this4.config, containerWidth);
    var currentBreakpoint = (0, _ci.getBreakPoint)(adaptiveSizes) || adaptiveSizes[0];
    var imageToLoad = sources.find(function (breakPoint) {
      return breakPoint.mediaQuery === currentBreakpoint.media;
    }).srcSet;

    if (!isPreview) {
      if (!isLazy) {
        _this4.addBackgroundSources(_this4.bgImageIndex, sources);

        var tempImage = new Image();
        tempImage.src = imageToLoad;

        tempImage.onload = function () {
          if (_this4.config.imgLoadingAnimation) {
            (0, _ci.finishAnimation)(image, true);
          }
        };
      } else {
        var responsiveCSS = _this4.addBackgroundSources(_this4.bgImageIndex, sources, true);

        image.setAttribute('ci-responsive-css', responsiveCSS);

        _this4.setBackgroundSrc(image, imageToLoad, isLazy);
      }
    } else {
      var config = _extends({}, _this4.config);

      var previewSources = (0, _ci.generateSources)(imgSrc, params, adaptiveSizes, config, containerWidth, true);
      var imagePreviewToLoad = previewSources.find(function (breakPoint) {
        return breakPoint.mediaQuery === currentBreakpoint.media;
      }).srcSet;

      if (!isLazy) {
        _this4.addBackgroundSources(_this4.bgImageIndex, sources);

        var _tempImage = new Image();

        _tempImage.src = imageToLoad;

        _tempImage.onload = function () {
          if (_this4.config.imgLoadingAnimation) {
            (0, _ci.finishAnimation)(image, true);
          }
        };
      } else {
        var _responsiveCSS = _this4.addBackgroundSources(_this4.bgImageIndex, sources, true);

        image.setAttribute('ci-responsive-css', _responsiveCSS);
        image.setAttribute('ci-optimized-url', imageToLoad);

        _this4.setBackgroundSrc(image, imagePreviewToLoad, isLazy);
      }
    }
  };
};

exports.default = CIResponsive;